//@flow
import * as React from 'react';
import { styled } from 'linaria/react';
import { codeSetCursor } from '../domain';
const Outline =
/*#__PURE__*/
styled("div")({
  name: "Outline",
  class: "o183vihf"
});
const Header =
/*#__PURE__*/
styled("div")({
  name: "Header",
  class: "h1envii3"
});
const Section =
/*#__PURE__*/
styled("section")({
  name: "Section",
  class: "s1n6wvus"
});
const EmptySection =
/*#__PURE__*/
styled("section")({
  name: "EmptySection",
  class: "eoh5afu"
});
const Item =
/*#__PURE__*/
styled("li")({
  name: "Item",
  class: "i2yk0jv",
  vars: {
    "i2yk0jv-0": [props => Boolean(props.loc) ? 'pointer' : 'inherit']
  }
});

const mapper = item => {
  const loc = item?.defaultConfig?.loc;
  const name = item?.compositeName?.fullName || item?.shortName || item.id || item.displayName;
  const key = item.kind && item.id ? item.kind + item.id + name : name;

  const onClick = () => {
    if (loc) codeSetCursor(loc);
  };

  return <Item loc={loc} onClick={onClick} key={key}>
      {name}
    </Item>;
};

const OutlineSection = ({
  list,
  title
}) => {
  if (list.length === 0) return null;
  return <>
      <Header>{title}</Header>
      <Section>
        <ol>{list.map(mapper)}</ol>
      </Section>
    </>;
};

export default function ({
  style,
  component,
  domain,
  event,
  effect,
  store
}) {
  const isEmpty = event.length === 0 && effect.length === 0 && store.length === 0 && domain.length === 0 && component.length === 0;
  return <Outline style={style}>
      {isEmpty && <EmptySection>Symbols weren&apos;t found in this file</EmptySection>}
      <OutlineSection list={event} title="Events" />
      <OutlineSection list={effect} title="Effects" />
      <OutlineSection list={store} title="Storages" />
      <OutlineSection list={domain} title="Domains" />
      <OutlineSection list={component} title="Components" />
    </Outline>;
}